module.exports = __webpack_public_path__ + "img/6.dafd3640.png";